import React, { useRef , useState } from 'react';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { TieredMenu } from 'primereact/tieredmenu';
import { Toast } from 'primereact/toast';

import {  useNavigate } from "react-router-dom";
import ConfirmaDialog from './ConfirmaDialog';



export default function Menu2() {
    const [theLogin,setTheLogin] = useState( false )
    const [confirmState,setConfirmState] = useState( false )
    const menuLeft = useRef(null);
    const menuRight = useRef(null);
    const toast = useRef(null);
    
    const navigate = useNavigate() ;

    function askLogin() // Preguntamos si entramos al login
    {
        console.log( "askLogin " )
        
        setConfirmState( !confirmState )
        setTheLogin( true ) ;

    }

    function setAnswer( val )
    {
        if( val === 1 )
        {
            navigate( "/")
        }
    }

    const items = [
       // {
            // label: 'Menu',
            // items: [
                {
                    label: 'Datos Nuevos',
                    icon: 'pi pi-upload' , 

                    
                        items : [
                            {
                                label : 'Carga Nuevos datos' ,
                                icon: 'pi pi-upload' , 
                                command: () => {
                                    navigate( "/uploadnew") ; toast.current.show({ severity: 'success', summary: 'Success', detail: 'Carga datos Nuevos', life: 6000 });
                                }
                            },
                            {
                                label : 'Visualiza Nuevos datos' ,
                                icon: 'pi pi-eye' , 
                                command: () => {
                                    /*navigate( "/uploadnew")*/ ; toast.current.show({ severity: 'success', summary: 'Success', detail: 'Visualiza datos Nuevos', life: 6000 });
                                }
                            }
                            
                        ]


                },
                {
                    label: 'Carga datos procesados',
                    icon: 'pi pi-database' ,
                    command: () => {
                        navigate( "/uploadprocesados") ; toast.current.show({ severity: 'success', summary: 'Success', detail: 'Carga datos Procesados', life: 6000 });
                    }

                    
                },
                {
                    label: 'Revisar Temporal',
                    icon: 'pi pi-clock' ,
                    command: () => {
                        navigate( "/reviewtemporal") ; toast.current.show({ severity: 'success', summary: 'Success', detail: 'Revisa Temporal', life: 6000 });
                    }

                    
                },
                {
                    label: 'Revisar Produccion',
                    icon: 'pi pi-clock' ,
                    command: () => {
                        navigate( "/reviewproduccion") ; toast.current.show({ severity: 'success', summary: 'Success', detail: 'Revisa Produccion', life: 6000 });
                    }

                    
                },
                {
                    label: 'Ver proceso',
                    icon: 'pi pi-eye' ,
                },
                {
                    label: 'Saldos',
                    icon: 'pi pi-book',
                    command: () => {
                        navigate( "/saldos")  ; toast.current.show({ severity: 'success', summary: 'Success', detail: 'Saldos', life: 6000 });
                    }

                },
                {
                    label: 'Inicio',
                    icon: 'pi pi-home',
                    command: () => {
                        /*navigate( "/")*/ askLogin() ; toast.current.show({ severity: 'success', summary: 'Success', detail: 'Go Home', life: 6000 });
                    }

                } ,

            //]
        //}
    ];

    return (
        <div className="card flex  justify-content-start " style={{borderWidth:0}}>
            <Toast ref={toast}></Toast>
            {/* <Menu model={items} popup ref={menuLeft} id="popup_menu_left" />
            <Button label="Show Left" icon="pi pi-align-left" className="mr-2" onClick={(event) => menuLeft.current.toggle(event)} aria-controls="popup_menu_left" aria-haspopup /> */}
            <TieredMenu model={items} popup ref={menuRight} id="popup_menu_left"  />
            <Button  icon="pi pi-align-left" size='large' style={{color:'black' , backgroundColor : 'lightblue' , borderWidth:0 }} 
                className="mr-0" onClick={(event) => menuRight.current.toggle(event)} aria-controls="popup_menu_left" aria-haspopup />

            {
                theLogin === true && (
                    <>
                    {/*<p>hola amigo</p>*/}
                    <ConfirmaDialog state={confirmState} answer={setAnswer}></ConfirmaDialog>
                    </>
                )

            }

        </div>
    )
}
        